import { useTranslation } from "react-i18next";

const BookingFooter = () => {
  const { t } = useTranslation('common');

  return (
    <footer className="hidden lg:block py-6 text-center bg-foreground/5">
      <div className="text-xs text-foreground/50">
        <span className="text-foreground/40">{t('POWERED_BY')} </span>
        <span
          className="font-['Playfair_Display'] font-bold tracking-wide text-transparent bg-clip-text bg-gradient-to-r from-[#FF3366] to-[#FF3366]"
        >
          Meitre
        </span>
      </div>
    </footer>
  );
};

export default BookingFooter;
